import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

export const payerOwnerValidationSchema = () =>
  Yup.object({
    payerOwner: Yup.object({
      payer: Yup.object({
        address: requiredText(),
        id: requiredText()
      }),
      ownerIsDifferent: Yup.boolean(),
      owner: Yup.object().when('ownerIsDifferent', {
        is: true,
        then: () =>
          Yup.object({
            address: requiredText(),
            id: requiredText()
          }),
        otherwise: () => Yup.object().strip()
      })
    })
  });
